(function () {
  'use strict';

  const initRotatingSection = (section) => {
    const isAutoplay = section.dataset.autoplay === 'true';
    
    if (isAutoplay) {
      // Autoplay mode - CSS animation only, no JavaScript needed
      return;
    }

    // Swiper mode - initialize Swiper.js
    const slider = section.querySelector('.swiper--rotating');
    if (!slider) return;

    // Add swiper-slide class to all slides
    const slides = slider.querySelectorAll('.rotating__slide');
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    const spaceBetween = section.dataset.spaceBetween 
      ? Number(section.dataset.spaceBetween) * 10 
      : 16;

    const loop = section.dataset.loop === 'true';
    const showArrows = section.dataset.showArrows === 'true';
    const showDots = section.dataset.showDots === 'true';

    const nextBtn = section.querySelector('.swiper-button-next');
    const prevBtn = section.querySelector('.swiper-button-prev');
    const pagination = section.querySelector('.swiper-pagination');

    const swiperConfig = {
      loop: loop,
      slidesPerView: 1.3,
      spaceBetween: spaceBetween,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      breakpoints: {
        576: {
          slidesPerView: 1.8,
          spaceBetween: spaceBetween,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: spaceBetween,
        },
        1024: {
          spaceBetween: spaceBetween,
          slidesPerView: 5,
        },
      },
    };

    // Add navigation if arrows are enabled
    if (showArrows && nextBtn && prevBtn) {
      swiperConfig.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'rotating__arrow--disabled',
      };
    }

    // Add pagination if dots are enabled
    if (showDots && pagination) {
      swiperConfig.pagination = {
        el: pagination,
        clickable: true,
        bulletClass: 'rotating__dot',
        bulletActiveClass: 'rotating__dot--active',
      };
    }

    // Initialize Swiper
    new Swiper(slider, swiperConfig);
  };

  // Initialize sections
  const initRotatingSections = () => {
    const sections = document.querySelectorAll('.rotating-section');
    sections.forEach(section => {
      initRotatingSection(section);
    });
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRotatingSections);
  } else {
    initRotatingSections();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('rotating-section')) {
      initRotatingSection(event.target);
    }
  });

  // Clean up on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('rotating-section')) {
      // Clean up any Swiper instances if needed
    }
  });
})(); 